const overlay = document.getElementById('builder-modal-overlay');
let activeModal = null;

// THE FIX: Renamed this to exactly match the HTML click events!
window.forceOpenModal = function(modalId) {
  if (overlay && overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  }
  if(overlay) overlay.classList.add('active');
  document.querySelectorAll('.custom-modal').forEach(m => m.classList.remove('active'));
  activeModal = document.getElementById(modalId);
  if (activeModal) activeModal.classList.add('active');
  document.body.style.overflow = 'hidden'; 
};

window.closeModals = function() {
  if(overlay) overlay.classList.remove('active');
  if(activeModal) activeModal.classList.remove('active');
  document.body.style.overflow = ''; 
  window.calculateTotal(); 
};

window.selectCard = function(labelElement) {
  const siblings = labelElement.parentElement.querySelectorAll('.selection-card');
  siblings.forEach(s => s.classList.remove('selected'));
  labelElement.classList.add('selected');
  window.calculateTotal(true); 
};

window.selectFabricModal = function(labelElement) {
  const siblings = labelElement.parentElement.querySelectorAll('.fabric-grid-item');
  siblings.forEach(s => s.classList.remove('selected'));
  labelElement.classList.add('selected');
  window.calculateTotal(true);
};

window.applyFabricSelection = function() {
  const selectedRadio = document.querySelector('input[name="temp-fabric"]:checked');
  if (selectedRadio) window.selectFabric(selectedRadio.value); 
  window.closeModals();
};

window.selectFabric = function(colorName) {
  const finalFabricEl = document.getElementById('final-fabric');
  if (finalFabricEl) finalFabricEl.value = colorName;
  
  const inlineNameDisplay = document.getElementById('inline-fabric-name');
  if (inlineNameDisplay) inlineNameDisplay.innerText = colorName;

  document.querySelectorAll('.swatch-circle[data-color]').forEach(circle => {
    if (circle.getAttribute('data-color') === colorName) circle.classList.add('active');
    else circle.classList.remove('active');
  });

  const radios = document.querySelectorAll('input[name="temp-fabric"]');
  const matchingModalRadio = Array.from(radios).find(r => r.value === colorName);
  
  if (matchingModalRadio) {
    matchingModalRadio.checked = true;
    document.querySelectorAll('.fabric-grid-item').forEach(item => item.classList.remove('selected'));
    matchingModalRadio.closest('.fabric-grid-item').classList.add('selected');
  }

  window.calculateTotal();
  window.filterGallery(colorName);
};

// --- ADVANCED FABRIC LOGIC ---
window.selectAdvancedFabric = function(type, colorName) {
  const finalInput = document.getElementById('final-fabric-' + type);
  if (finalInput) finalInput.value = colorName;
  
  const summaryDisplay = document.getElementById('summary-fabric-' + type);
  if (summaryDisplay) summaryDisplay.innerText = colorName;

  document.querySelectorAll('.swatch-circle.' + type + '-swatch').forEach(circle => {
    if (circle.getAttribute('data-color') === colorName) circle.classList.add('active');
    else circle.classList.remove('active');
  });

  const radios = document.querySelectorAll('input[name="temp-fabric-' + type + '"]');
  const matchingModalRadio = Array.from(radios).find(r => r.value === colorName);
  
  if (matchingModalRadio) {
    matchingModalRadio.checked = true;
    document.querySelectorAll('#modal-fabric-' + type + ' .fabric-grid-item').forEach(item => item.classList.remove('selected'));
    matchingModalRadio.closest('.fabric-grid-item').classList.add('selected');
  }

  window.calculateTotal();
  if (type === 'primary') window.filterGallery(colorName);
};

window.applyAdvancedFabricSelection = function(type) {
  const selectedRadio = document.querySelector('input[name="temp-fabric-' + type + '"]:checked');
  if (selectedRadio) window.selectAdvancedFabric(type, selectedRadio.value);
  window.closeModals();
};
// ----------------------------------

window.filterGallery = function(colorName) {
  const galleryItems = document.querySelectorAll('.product__media-item, .thumbnail-list__item, .product-media-container');
  galleryItems.forEach(item => {
    const img = item.querySelector('img');
    if (img && img.alt) {
      const altText = img.alt.trim();
      if (window.allFabricNames && window.allFabricNames.includes(altText)) {
        if (altText === colorName) item.style.display = ''; 
        else item.style.display = 'none'; 
      } 
    }
  });
};

window.evaluateDualConnection = function(sizeText) {
  const wrapper = document.getElementById('dual-connection-card-wrapper');
  if (!wrapper) return; // Only applies to Electric Beds

  const sizeLower = sizeText.toLowerCase();
  if (sizeLower.includes('kingsize (5ft)') || sizeLower.includes('super king (6ft)')) {
    wrapper.style.display = 'block';
  } else {
    wrapper.style.display = 'none';
    
    // Reset to "No Dual Connection" if they switch back to a smaller bed
    const finalDual = document.getElementById('final-dual-connection');
    if (finalDual) finalDual.value = 'No Dual Connection';
    const summaryText = document.getElementById('summary-dual-connection');
    if (summaryText) summaryText.innerText = 'No Dual Connection';

    const defaultRadio = document.querySelector('input[name="temp-dual-connection"][data-price="0"]');
    if (defaultRadio) {
       defaultRadio.checked = true;
       document.querySelectorAll('#modal-dual-connection .selection-card').forEach(c => c.classList.remove('selected'));
       defaultRadio.closest('.selection-card').classList.add('selected');
    }
  }
};

window.filterMattresses = function(sizeText) {
  if (!sizeText) return;
  let targetSize = sizeText;
  let mattressQty = 1;

  // Split logic for Electric Beds
  const finalDual = document.getElementById('final-dual-connection');
  if (finalDual) {
      const dualValue = finalDual.value.toLowerCase();
      const isSplit = dualValue.includes("no dual connection");
      const sizeLower = sizeText.toLowerCase();

      if (sizeLower.includes('kingsize (5ft)') && isSplit) {
          targetSize = 'Small Single (2ft6)';
          mattressQty = 2;
      } else if (sizeLower.includes('super king (6ft)') && isSplit) {
          targetSize = 'Single (3ft)';
          mattressQty = 2;
      }
  }

  // Store the required quantity for the cart & pricing
  const qtyInput = document.getElementById('final-mattress-qty');
  if (qtyInput) qtyInput.value = mattressQty;

  // Update UI summary text for 2x Mattresses
  const summaryMattressText = document.getElementById('summary-mattress-text');
  const finalMattressEl = document.getElementById('final-mattress');
  if (summaryMattressText && (!finalMattressEl || finalMattressEl.value === "")) {
     if (mattressQty === 2) {
        summaryMattressText.innerText = `Add 2x ${targetSize} Mattresses`;
     } else {
        summaryMattressText.innerText = "Add a mattress or more";
     }
  }

  const targetClean = targetSize.toLowerCase().replace(/[^a-z0-9]/g, '');

  document.querySelectorAll('.mattress-card').forEach(card => {
    const rawTags = card.getAttribute('data-tags') || "";
    const tagArray = rawTags.split('|');

    let hasMatch = false;
    for (let i = 0; i < tagArray.length; i++) {
      const cleanTag = tagArray[i].toLowerCase().replace(/[^a-z0-9]/g, '');
      if (cleanTag === targetClean && cleanTag !== "") {
        hasMatch = true;
        break;
      }
    }

    // --- UPDATE MODAL CARD UI (QTY & PRICE) ---
    const qtyDisplay = card.querySelector('.mattress-qty-display');
    const qtyVal = card.querySelector('.qty-val');
    const priceDisplay = card.querySelector('.mattress-price-display');
    
    if (priceDisplay) {
        const basePrice = window.parseFloat(priceDisplay.getAttribute('data-base-price') || 0);
        priceDisplay.innerText = '£' + (basePrice * mattressQty).toFixed(2);
    }

    if (qtyDisplay && qtyVal) {
        if (mattressQty > 1) {
            qtyDisplay.style.display = 'block';
            qtyVal.innerText = mattressQty;
        } else {
            qtyDisplay.style.display = 'none';
            qtyVal.innerText = '1';
        }
    }
    // -------------------------------------------

    if (hasMatch) {
      card.style.display = 'flex'; 
    } else {
      card.style.display = 'none'; 
      const radio = card.querySelector('input[type="radio"]');
      if (radio && radio.checked) {
        radio.checked = false;
        card.classList.remove('selected');
        
        const noMattress = document.querySelector('input[name="temp-mattress"][value=""]');
        if (noMattress) {
          noMattress.checked = true;
          noMattress.closest('.selection-card').classList.add('selected');
          if (finalMattressEl) finalMattressEl.value = "";
          if (summaryMattressText) summaryMattressText.innerText = (mattressQty === 2) ? `Add 2x ${targetSize} Mattresses` : "No Mattress";
          const imgEl = document.getElementById('summary-mattress-img');
          if(imgEl) imgEl.src = "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
        }
      }
    }
  });
};

window.applySelection = function(type) {
    const selected = document.querySelector(`input[name="temp-${type}"]:checked`);
    if (!selected) { window.closeModals(); return; }
  
    if (type === 'mattress') {
      document.getElementById('final-mattress').value = selected.value;
      const matQty = window.parseInt(document.getElementById('final-mattress-qty')?.value || 1);
      const title = selected.getAttribute('data-title');
      document.getElementById('summary-mattress-text').innerText = (matQty === 2 && title !== 'No Mattress') ? `2x ${title}` : title;
      
      const imgUrl = selected.getAttribute('data-img');
      const imgEl = document.getElementById('summary-mattress-img');
      if(imgEl) imgEl.src = imgUrl ? imgUrl : "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
    } else {
      const finalInput = document.getElementById(`final-${type}`);
      if(finalInput) finalInput.value = selected.value;
      
      const summaryText = document.getElementById(`summary-${type}`);
      if(summaryText) {
          summaryText.innerText = selected.getAttribute('data-title') || selected.value;
      }
  
      if (finalInput && finalInput.getAttribute('data-is-size') === 'true') {
        window.evaluateDualConnection(selected.value);
        window.filterMattresses(selected.value);
      }
      
      if (type === 'dual-connection') {
        const sizeInput = document.querySelector('input[data-is-size="true"]');
        if (sizeInput) window.filterMattresses(sizeInput.value);
      }
    }
    window.closeModals();
};

window.getMatchedNativeVariant = function(isPreview = false) {
    if (!window.bedVariants) return null;
  
    let searchParams = { option1: null, option2: null, option3: null };
  
    for (let i = 1; i <= 3; i++) {
      const el = document.getElementById(`final-native-${i}`);
      if (el) {
        let val = el.value;
        const activeModal = document.querySelector('.custom-modal.active');
        if (isPreview && activeModal && activeModal.id === `modal-native-${i}`) {
           const checked = document.querySelector(`input[name="temp-native-${i}"]:checked`);
           if(checked) val = checked.value;
        }
        searchParams[`option${i}`] = val;
      }
    }
  
    return window.bedVariants.find(v => {
      if (searchParams.option1 && v.option1 !== searchParams.option1) return false;
      if (searchParams.option2 && v.option2 !== searchParams.option2) return false;
      if (searchParams.option3 && v.option3 !== searchParams.option3) return false;
      return true;
    }) || window.bedVariants[0];
};
  
window.calculateTotal = function(isPreview = false) {
  const matchedVariant = window.getMatchedNativeVariant(isPreview);
  let basePrice = matchedVariant ? window.parseFloat(matchedVariant.price) : 0;
  
  let baseComparePrice = (matchedVariant && matchedVariant.compare_at_price) ? window.parseFloat(matchedVariant.compare_at_price) : basePrice;

  let extrasTotal = 0;
  
  ['fabric', 'fabric-primary', 'fabric-accent', 'fabric-piping', 'headboard', 'siderail', 'assembly', 'mattress', 'dual-connection'].forEach(type => {
    let selectedRadio = null;
    const activeModal = document.querySelector('.custom-modal.active');

    if (isPreview && activeModal && activeModal.id === `modal-${type}`) {
       selectedRadio = document.querySelector(`input[name="temp-${type}"]:checked`);
    } else {
       const finalValElement = document.getElementById(`final-${type}`);
       if(finalValElement) {
           const finalVal = finalValElement.value;
           const radios = document.querySelectorAll(`input[name="temp-${type}"]`);
           selectedRadio = Array.from(radios).find(r => r.value === finalVal);
       }
    }
    if (selectedRadio && selectedRadio.value !== "") {
       let itemPrice = window.parseFloat(selectedRadio.getAttribute('data-price') || 0);
       
       // If 2x mattresses are needed, multiply the price
       if (type === 'mattress') {
           const matQty = window.parseInt(document.getElementById('final-mattress-qty')?.value || 1);
           itemPrice = itemPrice * matQty;
       }
       extrasTotal += itemPrice;
    }
  });

  const qtyInput = document.getElementById('bundle-quantity');
  const qty = qtyInput ? (window.parseInt(qtyInput.value) || 1) : 1;
  
  const finalTotal = (basePrice + extrasTotal) * qty;
  const finalCompareTotal = (baseComparePrice + extrasTotal) * qty; 
  
  document.querySelectorAll('.dynamic-total-price').forEach(el => el.innerText = '£' + finalTotal.toFixed(2));
  
  const compareElements = document.querySelectorAll('.dynamic-compare-price');
  const saveElements = document.querySelectorAll('.dynamic-save-badge');

  if (finalCompareTotal > finalTotal) {
      const saving = finalCompareTotal - finalTotal;
      compareElements.forEach(el => {
          el.innerText = '£' + finalCompareTotal.toFixed(2);
          el.style.display = 'inline-block';
      });
      saveElements.forEach(el => {
          let formattedSaving = saving % 1 === 0 ? saving.toFixed(0) : saving.toFixed(2);
          el.innerText = 'Save £' + formattedSaving;
          el.style.display = 'inline-block';
      });
  } else {
      compareElements.forEach(el => el.style.display = 'none');
      saveElements.forEach(el => el.style.display = 'none');
  }
  
  const amountIn3 = (finalTotal / 3).toFixed(2);
  const amountIn4 = (finalTotal / 4).toFixed(2);
  document.querySelectorAll('.dynamic-price-3').forEach(el => el.innerText = '£' + amountIn3);
  document.querySelectorAll('.dynamic-price-4').forEach(el => el.innerText = '£' + amountIn4);
};

window.updateLinkedOptions = function() {
  if (!window.bedVariants) return;
  const getVal = (idx) => {
    const checked = document.querySelector(`input[name="temp-native-${idx}"]:checked`);
    return checked ? checked.value : null;
  };

  let opt1 = getVal(1);
  let opt2 = getVal(2);

  if (opt1) {
    let validOpt2s = new Set();
    window.bedVariants.forEach(v => {
      if (v.option1 === opt1 && v.option2) validOpt2s.add(v.option2);
    });
    let opt2Radios = document.querySelectorAll('input[name="temp-native-2"]');
    if (opt2Radios.length > 0) {
      let hasValidSelection = false;
      let firstValid = null;

      opt2Radios.forEach(radio => {
        let card = radio.closest('.selection-card');
        if (validOpt2s.has(radio.value)) {
          card.style.display = 'flex'; 
          if (!firstValid) firstValid = radio;
          if (radio.checked) hasValidSelection = true;
        } else {
          card.style.display = 'none'; 
        }
      });
      
      if (!hasValidSelection && firstValid) {
        firstValid.checked = true;
        opt2Radios.forEach(r => r.closest('.selection-card').classList.remove('selected'));
        firstValid.closest('.selection-card').classList.add('selected');
        const finalInput = document.getElementById('final-native-2');
        const summarySpan = document.getElementById('summary-native-2');
        if (finalInput) finalInput.value = firstValid.value;
        if (summarySpan) summarySpan.innerText = firstValid.value;
      }
    }
  }

  opt2 = getVal(2);
  if (opt1 && opt2) {
    let validOpt3s = new Set();
    window.bedVariants.forEach(v => {
      if (v.option1 === opt1 && v.option2 === opt2 && v.option3) validOpt3s.add(v.option3);
    });
    let opt3Radios = document.querySelectorAll('input[name="temp-native-3"]');
    if (opt3Radios.length > 0) {
      let hasValidSelection = false;
      let firstValid = null;

      opt3Radios.forEach(radio => {
        let card = radio.closest('.selection-card');
        if (validOpt3s.has(radio.value)) {
          card.style.display = 'flex';
          if (!firstValid) firstValid = radio;
          if (radio.checked) hasValidSelection = true;
        } else {
          card.style.display = 'none';
        }
      });
      
      if (!hasValidSelection && firstValid) {
        firstValid.checked = true;
        opt3Radios.forEach(r => r.closest('.selection-card').classList.remove('selected'));
        firstValid.closest('.selection-card').classList.add('selected');
        const finalInput = document.getElementById('final-native-3');
        const summarySpan = document.getElementById('summary-native-3');
        if (finalInput) finalInput.value = firstValid.value;
        if (summarySpan) summarySpan.innerText = firstValid.value;
      }
    }
  }
  window.calculateTotal(true);
};

window.handleAssemblyPostcodeVisibility = function(element) {
  const input = element.querySelector('input[type="radio"]');
  const price = window.parseFloat(input.getAttribute('data-price') || 0);
  const wrapper = document.getElementById('assembly-postcode-wrapper');
  const searchBox = document.getElementById('assembly-postcode-search');
  const hiddenSelect = document.getElementById('assembly-postcode-select');
  if (price > 0) {
    wrapper.style.display = 'block';
  } else {
    wrapper.style.display = 'none';
    if(searchBox) searchBox.value = ""; 
    if(hiddenSelect) hiddenSelect.value = "";
  }
};

window.validateAndApplyAssembly = function() {
  const checked = document.querySelector('input[name="temp-assembly"]:checked');
  const price = window.parseFloat(checked.getAttribute('data-price') || 0);
  const hiddenSelect = document.getElementById('assembly-postcode-select');
  const searchBox = document.getElementById('assembly-postcode-search');
  
  if (price > 0 && hiddenSelect.value === "") {
    window.alert('Please search and select your postcode area from the dropdown list to confirm availability.');
    if (searchBox) searchBox.focus();
    return;
  }

  const finalPostcodeInput = document.getElementById('final-assembly-postcode');
  if (finalPostcodeInput) {
    finalPostcodeInput.value = price > 0 ? hiddenSelect.value : "";
  }

  window.applySelection('assembly');
  
  const summarySpan = document.getElementById('summary-assembly');
  if (price > 0 && hiddenSelect.value !== "" && summarySpan) {
    summarySpan.innerHTML = (checked.getAttribute('data-title') || checked.value) + " <br><strong style='font-size:12px; color:#555;'>(" + hiddenSelect.value + ")</strong>";
  }
};

window.calculateDeliveryDate = function(leadDays) {
    let count = 0;
    const currentDate = new Date();
    while (count < leadDays) {
        currentDate.setDate(currentDate.getDate() + 1);
        const dayOfWeek = currentDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) { count++; }
    }
    const options = { weekday: 'short', day: 'numeric', month: 'short' };
    return currentDate.toLocaleDateString('en-GB', options).replace(/,/g, '');
};

window.updateDeliveryMessage = function() {
    const leadDaysInput = document.getElementById('delivery-lead-days');
    if (!leadDaysInput) return;
    const leadDays = window.parseInt(leadDaysInput.value) || 5;
    const formattedDate = window.calculateDeliveryDate(leadDays);
    const messageElement = document.getElementById('delivery-estimate-text');
    if (messageElement) {
        messageElement.innerText = `Delivery available before ${formattedDate}`;
    }
};

window.isAddingToCartBespoke = false;

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(window.updateLinkedOptions, 100); 
  window.calculateTotal(); 
  window.updateDeliveryMessage();
  
  const allNativeInputs = document.querySelectorAll('[id^="final-native-"]');
  allNativeInputs.forEach(input => {
      if (input.getAttribute('data-is-size') === 'true') {
          window.evaluateDualConnection(input.value);
          window.filterMattresses(input.value);
      }
  });
  
  const qtyInput = document.getElementById('bundle-quantity');
  if(qtyInput) {
      const btnPlus = document.getElementById('qty-plus');
      const btnMinus = document.getElementById('qty-minus');
      if (btnPlus) btnPlus.addEventListener('click', () => { qtyInput.value = window.parseInt(qtyInput.value) + 1; window.calculateTotal(); });
      if (btnMinus) btnMinus.addEventListener('click', () => { 
        if (window.parseInt(qtyInput.value) > 1) { qtyInput.value = window.parseInt(qtyInput.value) - 1; window.calculateTotal(); }
      });
  }

  const addToCartBtn = document.getElementById('custom-add-to-cart');
  if (addToCartBtn) {
    
    // Apply listener lock 
    if (!addToCartBtn.hasAttribute('data-js-attached')) {
      addToCartBtn.setAttribute('data-js-attached', 'true');

      addToCartBtn.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (window.isAddingToCartBespoke) return;
        window.isAddingToCartBespoke = true;

        const btn = this; 
        const originalText = btn.innerText;
        btn.innerText = 'ADDING...'; 
        btn.style.pointerEvents = 'none';

        const globalQty = window.parseInt(document.getElementById('bundle-quantity').value) || 1;
        let itemsToAdd = [];
        const bundleId = 'bed_' + Date.now();
        
        const matchedVariant = window.getMatchedNativeVariant(false);
        if (matchedVariant) {
          let cartProps = { "_bundle_id": bundleId }; 
          
          const fabricEl = document.getElementById('final-fabric');
          if (fabricEl) cartProps["Fabric"] = fabricEl.value;

          const primaryEl = document.getElementById('final-fabric-primary');
          if (primaryEl) cartProps["Primary Colour"] = primaryEl.value;
          const accentEl = document.getElementById('final-fabric-accent');
          if (accentEl) cartProps["Accent Colour"] = accentEl.value;
          const pipingEl = document.getElementById('final-fabric-piping');
          if (pipingEl) cartProps["Piping Colour"] = pipingEl.value;
          
          const headboardEl = document.getElementById('final-headboard');
          if (headboardEl) cartProps["Headboard Height"] = headboardEl.value;
          
          const siderailEl = document.getElementById('final-siderail');
          if (siderailEl) cartProps["Side Rail"] = siderailEl.value;
          
          const assemblyEl = document.getElementById('final-assembly');
        // Only send assembly if it's not empty and not "Add assembly"
        if (assemblyEl && assemblyEl.value !== "" && assemblyEl.value !== "Add assembly") {
            cartProps["Assembly"] = assemblyEl.value;
        }

        const assemblyPostcodeEl = document.getElementById('final-assembly-postcode');
        if (assemblyPostcodeEl && assemblyPostcodeEl.value !== "" && assemblyEl && assemblyEl.value !== "" && assemblyEl.value !== "Add assembly") {
            cartProps["Assembly Postcode"] = assemblyPostcodeEl.value;
        }

          itemsToAdd.push({ id: matchedVariant.id, quantity: globalQty, properties: cartProps });
        }
        
        ['fabric', 'fabric-primary', 'fabric-accent', 'fabric-piping', 'headboard', 'siderail', 'assembly', 'dual-connection'].forEach(type => {
        const finalEl = document.getElementById(`final-${type}`);
        if (finalEl && finalEl.value !== "") {
            const finalVal = finalEl.value;
            
            // Skip "Add assembly" from being treated as a real product addon
            if (type === 'assembly' && (finalVal === 'Add assembly' || finalVal === '')) return;

            const radios = document.querySelectorAll(`input[name="temp-${type}"]`);
            const radio = Array.from(radios).find(r => r.value === finalVal);
            if (radio && radio.getAttribute('data-addon-id')) {
              itemsToAdd.push({ id: window.parseInt(radio.getAttribute('data-addon-id')), quantity: globalQty, properties: { "_bundle_id": bundleId, "_is_addon": "true" } });
            }
        }
      });

        const finalMattressEl = document.getElementById('final-mattress');
        if (finalMattressEl && finalMattressEl.value) {
            const matQtyMultiplier = window.parseInt(document.getElementById('final-mattress-qty')?.value || 1);
            itemsToAdd.push({ 
                id: window.parseInt(finalMattressEl.value), 
                quantity: globalQty * matQtyMultiplier, 
                properties: { 
                    "_bundle_id": bundleId, 
                    "_is_mattress": "true", 
                    "Note": "Paired with bed",
                    "_mattress_multiplier": matQtyMultiplier.toString()
                } 
            });
        }

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: itemsToAdd })
          });
          if (response.ok) { 
            window.location.href = '/cart'; 
          } else {
            const errorData = await response.json();
            window.alert('Error: ' + errorData.description);
            btn.innerText = originalText; 
            btn.style.pointerEvents = 'auto';
            window.isAddingToCartBespoke = false;
          }
        } catch(error) {
          console.error('Error:', error);
          btn.innerText = originalText; 
          btn.style.pointerEvents = 'auto';
          window.isAddingToCartBespoke = false;
        }
      });
    }
  }

  const searchInput = document.getElementById('assembly-postcode-search');
  const list = document.getElementById('assembly-postcode-list');
  const hiddenSelect = document.getElementById('assembly-postcode-select');
  
  if(searchInput && list) {
    searchInput.addEventListener('focus', () => list.classList.add('active'));
    searchInput.addEventListener('click', () => list.classList.add('active'));

    searchInput.addEventListener('input', function() {
      const filter = this.value.toLowerCase();
      const items = list.querySelectorAll('li:not(.no-results)');
      items.forEach(item => {
        const text = item.textContent.toLowerCase();
        if(text.includes(filter)) item.classList.remove('hidden');
        else item.classList.add('hidden');
      });
      hiddenSelect.value = "";
    });

    list.addEventListener('click', function(e) {
      if(e.target.tagName === 'LI' && !e.target.classList.contains('no-results')) {
        searchInput.value = e.target.textContent;
        hiddenSelect.value = e.target.getAttribute('data-value');
        list.classList.remove('active');
        list.querySelectorAll('li').forEach(li => li.classList.remove('hidden'));
      }
    });
    
    document.addEventListener('click', function(e) {
      if(!searchInput.contains(e.target) && !list.contains(e.target)) {
        list.classList.remove('active');
        if (hiddenSelect.value === "" && searchInput.value.trim() !== "") {
           const exactMatch = Array.from(list.querySelectorAll('li')).find(li => li.textContent.toLowerCase() === searchInput.value.trim().toLowerCase());
           if(exactMatch) {
             hiddenSelect.value = exactMatch.getAttribute('data-value');
             searchInput.value = exactMatch.textContent;
           } else {
             searchInput.value = "";
           }
        }
      }
    });
  }
});